import { catchError, filter, map, mergeMap } from 'rxjs/operators'
import { deleteWorkspaceState } from '../../../Repository/Visualization/WorkspaceStates.js'
import { of } from 'rxjs'
import type { Epic } from '../../index.js'
import { Actions } from '../../Slice/index.js'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.js'

export const deleteRemoteViewEpic: Epic = (action$) => {
  const v = Actions[visualizationSlice.name]
  return action$.pipe(
    filter(v.remoteDeleteRequest.match),
    mergeMap((a) => {
      const { id, modifiedAt } = a.payload
      return deleteWorkspaceState(id, { modifiedAt }).pipe(
        map(() => v.remoteDeleteSuccess({ id })),
        catchError((e) => of(v.remoteDeleteFailure({ error: String(e) })))
      )
    })
  )
}
